import React from "react";
import "../styles/AboutSection.css";

import { FaCheckCircle } from "react-icons/fa";
import glove from "../images/services/glove.png";
import { useRef } from "react";
import { useEffect } from "react";

const About = () => {

  const servicesRef = useRef(null);
          
       useEffect (() => {
        const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
         const scrollReveal = () => {
            for (let i = 0; i < revealElements.length; i++) {
             const elementIsInScreen =
            revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
          
          if (elementIsInScreen) {
           revealElements[i].classList.add("revealed");
           } else {
              revealElements[i].classList.remove("revealed");
               }
            }
           };
          
           window.addEventListener("scroll", scrollReveal);
              scrollReveal(); // Initial check
          
              return () => {
                window.removeEventListener("scroll", scrollReveal);
              };
            }, []);


  return (
    <section className="about-section" ref={servicesRef}>
      <div className="about-header">
        <span data-reveal>About us</span>
        <h2 data-reveal>Honest. Simple. Clean.</h2>
        <p data-reveal>Your satisfaction is our priority.</p>
      </div>

      <div className="about-container">
        <div className="about-left">
          <div className="about-item">
            <FaCheckCircle className="about-icon" data-reveal="left"/>
            <div>
              <h4 data-reveal>Trust</h4>
              <p data-reveal>
                Trust is our paramount value. All employees go through work
                authorization checks.
              </p>
            </div>
          </div>

          <div className="about-item">
            <FaCheckCircle className="about-icon" data-reveal="left"/>
            <div>
              <h4 data-reveal>Quality</h4>
              <p data-reveal>
                Excellent performance, fair pricing, and reliable service every
                time.
              </p>
            </div>
          </div>

          <div className="about-item">
            <FaCheckCircle className="about-icon" data-reveal="left"/>
            <div>
              <h4 data-reveal>Care</h4>
              <p data-reveal>
                We respond quickly and handle every car, carpet, and space with
                care.
              </p>
            </div>
          </div>

          <div className="about-item">
            <FaCheckCircle className="about-icon" data-reveal="left"/>
            <div>
              <h4 data-reveal>People</h4>
              <p data-reveal>
                We value our customers and provide friendly, professional
                service.
              </p>
            </div>
          </div>
        </div>

        <div className="about-right">
          <div className="about-card">
            <div className="about-card-text">
              <h1 data-reveal="left">96%</h1>
              <h3 data-reveal>Satisfaction Rate*</h3>
              <p data-reveal>*Based on customer feedback</p>
            </div>

    <div className="about-card-image"data-reveal="right">
      <img src={glove} alt="Satisfaction hand" />
    </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;